import React from 'react';
import styled from 'styled-components';
import Title from './Title';

const Container = styled.section`
    grid-row: 4;
    grid-column: 1;
    h2 {
        margin-top: 0;
        font-size: clamp(1rem, 1.5vw + 0.3rem, 1.75rem);
        font-weight: 700;
    }

    p {
        margin-top: 0;
        font-size: clamp(1rem, 1vw + 0.3rem, 1.3rem);
    }
`;

const Education = () => {
    return (
        <Container id='edu'>
            {Title('04', 'EDU')}
            <h2 style={{ fontWeight: '700' }}>
                saint-petersburg polytechnic university (2019 - 2023)
            </h2>
            <p>fundamental computer science and information technology</p>
        </Container>
    );
};

export default Education;
